import { useMap } from "@vis.gl/react-google-maps";

import Slider from "@mui/material/Slider";
import { useEffect } from "react";

import { useNitroStore } from "../../../store/Store";
import { useIsMobile } from "../../../hooks/useIsMobile";

const Zoom = () => {
  const isMobile = useIsMobile(768);
  const map = useMap();

  const [zoom, setZoom] = useNitroStore((state) => [state.zoom, state.setZoom]);

  useEffect(() => {
    if (!map) return;
    if (!setZoom) return;

    const listener = () => {
      const newZoom = map.getZoom();

      if (newZoom) {
        setZoom(newZoom);
      }
    };

    map.addListener("zoom_changed", listener);
  }, [map, setZoom]);

  return (
    <div
      className="zoom"
      style={{
        display: isMobile ? "none" : "block",
        // zIndex: 10,
        position: "fixed",
        right: 20,
        width: 180,
        bottom: 20,
      }}
    >
      <Slider
        marks
        step={1}
        orientation="horizontal"
        value={zoom}
        max={20}
        min={5}
        valueLabelDisplay="auto"
        onChange={(e, value) => {
          if (map) {
            map.setZoom(value as number);
          }
        }}
      />
    </div>
  );
};

export default Zoom;
